@if (gridFilterService) { @for (gridFilter of gridFilterService.filtersWithAppliedValues; track $index) {
<mf-grid-filter-tag
  [filter]="gridFilter"
  [gridFilterService]="gridFilterService" />
}}
